import { useCallback, useEffect, useState } from 'react';
import postWorkflowMessage from '../../../../utils/post-workflow-message';

export default () => {
  const [isInProgress, setIsInProgress] = useState(false);
  const onInveriteMessage = useCallback(
    (event) => {
      if (!event.origin.match(/^https:\/\/.+\.inverite\.com/ig)) return;
      const {
        data: {
          detail,
        } = {},
      } = event;
      if (isInProgress) {
        postWorkflowMessage('WORKFLOW_IN_PROGRESS');
      } else if (detail === 'choose_bank') {
        setIsInProgress(true);
        postWorkflowMessage('WORKFLOW_READY');
      }
    },
    [isInProgress],
  );

  useEffect(() => {
    window.addEventListener('message', onInveriteMessage);
    return () => window.removeEventListener('message', onInveriteMessage);
  }, [onInveriteMessage]);

  return { isInProgress };
};
